import { render, staticRenderFns } from "./NavBottom.vue?vue&type=template&id=71fd8483&scoped=true&"
import script from "./NavBottom.vue?vue&type=script&lang=js&"
export * from "./NavBottom.vue?vue&type=script&lang=js&"
import style0 from "./NavBottom.vue?vue&type=style&index=0&id=71fd8483&prod&lang=css&"
import style1 from "./NavBottom.vue?vue&type=style&index=1&id=71fd8483&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71fd8483",
  null
  
)

export default component.exports